import React from 'react';
import { motion } from 'framer-motion';
import { Users, Trophy, Star, MapPin, Package, Truck } from 'lucide-react';
import { handleWhatsAppClick } from '@/lib/whatsapp.js';
import WhatsAppIcon from './WhatsAppIcon.jsx';

const TrustProofSection = () => {
  const stats = [
    {
      num: "500+",
      label: "Parceiros Comerciais",
      desc: "Negócios que confiam em nós",
      icon: Users,
      bg: "bg-[#E0F7F4]"
    },
    {
      num: "35",
      label: "Anos de Tradição",
      desc: "Experiência e confiabilidade",
      icon: Trophy,
      bg: "bg-[#E3F2FD]"
    },
    {
      num: "4.9/5",
      label: "Satisfação dos Clientes",
      desc: "Qualidade reconhecida",
      icon: Star,
      bg: "bg-[#E0F7F4]"
    },
    {
      num: "100%",
      label: "Cobertura no RS",
      desc: "Entrega em todo o estado",
      icon: MapPin,
      bg: "bg-[#E3F2FD]"
    },
    {
      num: "50 Mi",
      label: "Produtos Fabricados",
      desc: "Escala e produção contínua",
      icon: Package,
      bg: "bg-[#E0F7F4]"
    },
    {
      num: "100%",
      label: "Frota Própria",
      desc: "Logística de qualidade",
      icon: Truck,
      bg: "bg-[#E3F2FD]"
    }
  ];

  return (
    <section id="confianca" className="py-[60px] bg-background">
      <div className="container-custom relative z-10">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-[#1F2937] max-w-4xl mx-auto leading-tight text-balance">
            Por Que Centenas de Negócios Confiam na Hiperpan
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-6 gap-[24px]">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1, ease: "easeOut" }}
              className={`min-h-[180px] p-[30px] rounded-2xl flex flex-col items-center text-center shadow-sm hover:scale-105 hover:shadow-lg transition-all duration-300 cursor-pointer ${stat.bg}`}
            >
              <div className="w-[64px] h-[64px] rounded-full bg-[#E0F7F4] border-[3px] border-white flex items-center justify-center mb-[16px] shadow-sm shrink-0">
                <stat.icon className="w-[32px] h-[32px] text-[#10B981]" />
              </div>
              
              <div className="text-[48px] font-bold text-[#1F2937] leading-none mb-[12px] tracking-tight">
                {stat.num}
              </div>
              
              <div className="font-bold text-[11px] tracking-wider uppercase text-[#1F2937]/80 mb-1">
                {stat.label}
              </div>
              
              <div className="text-[#6B7280] text-[12px] sm:text-[13px] font-medium leading-snug line-clamp-2">
                {stat.desc}
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-[40px] flex flex-col items-center justify-center text-center">
          <button
            data-gtm="whatsapp"
            onClick={() => handleWhatsAppClick('Olá! Vi os números impressionantes da Hiperpan e gostaria de saber mais sobre como vocês podem ajudar meu negócio. Qual é o próximo passo?')}
            className="gtm-whatsapp bg-[#10B981] hover:bg-[#059669] text-white px-8 py-4 rounded-xl font-bold flex items-center justify-center gap-2 text-base md:text-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-300"
          >
            <WhatsAppIcon className="w-6 h-6" />
            QUERO FAZER PARTE DESSA HISTÓRIA
          </button>
          <p className="mt-3 text-sm text-[#6B7280] font-medium">
            Consultor disponível agora
          </p>
        </div>
      </div>
    </section>
  );
};

export default TrustProofSection;